import { useState, useEffect } from "react";
import "./css/carruselDrawings.css"
import btnLeft from "../../resources/img/carrusel/btn-left-green.svg";
import btnRight from "../../resources/img/carrusel/btn-right-green.svg";
import PropTypes from "prop-types";
import DrawingsModal from "../modals/drawingsModal/DrawingsModal";

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
};

const CarruselDrawings = ({
  paintings = [],
  carouselId = "paintingsCarousel",
}) => {
    const isMobile = useIsMobile();
    const chunkSize = isMobile ? 1 : 4;
    const chunkedPaintings = [];
    const [showModal, setShowModal] = useState(false);
    const [drawingData, setDrawingData] = useState(null);

    const handleOpenDrawingModal = (data) => {
      setShowModal(true);
      setDrawingData(data);
    };

    for (let i = 0; i < paintings.length; i += chunkSize) {
        chunkedPaintings.push(paintings.slice(i, i + chunkSize));
    }
  
    return (
      <div
        id={carouselId}
        className="carousel slide my-5"
        data-bs-ride="carousel"
        data-bs-interval="3000"
      >
        <div className="carousel-inner">
          {chunkedPaintings.map((group, index) => (
            <div
              key={index}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
            >
              <div className="d-flex justify-content-center gap-4 py-4">
                {group.map((paint) => (
                  <div 
                    key={paint.id} 
                    className="col-auto cursor-pointer" 
                    onClick={() => handleOpenDrawingModal(paint)}
                    >
                    <div className="position-relative overflow-hidden rounded-4 gallery-item">
                      <img src={paint.img} alt={paint.alt} className="img-fluid" />
                      <div className="overlay d-flex flex-column justify-content-center align-items-center text-white text-center px-3">
                        <div className="color-text-gris-28-hv">{paint.title}</div>
                        <div className="color-text-14-hv">{paint.technique}</div>
                        <div className="color-text-14-hv">{paint.measures}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
  
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target={`#${carouselId}`}
          data-bs-slide="prev"
        >
          <img src={btnLeft} alt="prev" width="29" height="58" />
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target={`#${carouselId}`}
          data-bs-slide="next"
        >
          <img src={btnRight} alt="next" width="29" height="58" />
        </button>

        {showModal && drawingData && (
        <DrawingsModal
          key={drawingData.id} 
          drawing={drawingData}
          onClose={() => setShowModal(false)}
        />
      )}
      </div>
    );

}

CarruselDrawings.propTypes = {
    paintings: PropTypes.any,
    carouselId: PropTypes.string,
  };

export default CarruselDrawings
